import React from "react";
import MapComponent from "../components/map/mapcomponent";
import SideNav from "../components/navbar/sidenav/sideNav";

function Map({
  lang,
  isRadiusVisible,
  showPlaces,
  showRoads,
  onHideRadius,
  isOverlayHidden,
  onLandmarksClick, // جديد
  onRoadsClick,
  isDevsActive,
  setIsDevsActive,
}) {
  return (
    <>
      {/* الـ SideNav هنا داخل صفحة الماب بس */}
      <SideNav
        lang={lang}
        onLandmarksClick={onLandmarksClick}
        onRoadsClick={onRoadsClick}
        showPlaces={showPlaces}
        showRoads={showRoads}
        isDevsActive={isDevsActive}
        onDevsClick={() => setIsDevsActive((prev) => !prev)}
      />

      {/* الماب الفعلي */}
      <MapComponent
        isRadiusVisible={isRadiusVisible}
        showPlaces={showPlaces}
        showRoads={showRoads}
        onHideRadius={onHideRadius}
        isOverlayHidden={isOverlayHidden}
        isDevsActive={isDevsActive}
        setIsDevsActive={setIsDevsActive}
      />
    </>
  );
}

export default Map;
